export const backlogsteps = () => [
  {
    target: '[data-tour="backlog-search"]',
    title: 'Search Backlog',
    content: 'Search backlog items by title or keyword.',
    disableBeacon: true,
  },
 {
  target: '[data-tour="backlog-filters"]',
  title: 'Filters',
  content: 'Filter backlog items using Epic and Issue Type.',
  placement: 'bottom',
  disableBeacon: true,
  //  disableScrolling: true,
},
  {
    target: '[data-tour="backlog-list"]',
    title: 'Backlog',
    content: 'View and prioritize all work items that are not yet planned into a sprint.',
     disableBeacon: true,
  },
  {
    target: '[data-tour="create-sprint"]',
    title: 'Create Sprint',
    content: 'Create a sprint and move backlog items into it for execution.',
     disableBeacon: true,
  },
];